export default __webpack_public_path__ + "static/42-45 Sigh et al-65d9d67dc33d50073502b8aebf2c1beb.pdf";